import { render } from "./ControlloCorsi.vue?vue&type=template&id=504227ee&scoped=true"
import script from "./ControlloCorsi.vue?vue&type=script&lang=js"
export * from "./ControlloCorsi.vue?vue&type=script&lang=js"

import "./ControlloCorsi.vue?vue&type=style&index=0&id=504227ee&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-504227ee"]])

export default __exports__